// Don't use `rem` units for anything since existing CSS `font-size` affects all rem units
// https://github.com/am-systems/am-web-properties/blob/c1d44502a5babfe955a7f7462eba23658a73bbe3/public/thecreditreview/css/top-services/media-query.css#L22-L25.
// Existing `rem` units are migrated values from old styles to avoid breaking layouts.
export const getStyles = () => ({
	featuredCompanyHeader: {
		wrapper:
			"tw:bg-[#EDF4FE] tw:text-center tw:text-balance tw:rounded-t-[3px] tw:py-[8px] tw:px-[20px]",
		contentWrapper:
			"tw:text-[#333641] tw:font-semibold tw:leading-[24px] tw:text-[16px] tw:tracking-[-0.16px]",
	},
	serviceFlag: {
		wrapper:
			"tw:absolute tw:top-[16px] tw:left-[-8px] tw:flex tw:desktop:top-[24px]",
		flag: `tw:w-[28px] tw:h-[28px] tw:bg-[#0D8AE3] tw:flex tw:items-center tw:justify-center tw:rounded-[3px]`,
		number:
			"tw:text-white tw:text-[12px] tw:m-0 tw:pt-[2px] tw:font-semibold tw:leading-[16px]",
		text: "tw:relative tw:ml-[2px] tw:h-[28px] tw:rounded-[3px] tw:pl-[8px] tw:pt-[7px] tw:pb-[5px] tw:flex tw:items-center tw:justify-center tw:bg-[#0D8AE3] tw:text-white tw:text-[12px] tw:font-semibold tw:leading-[16px] tw:after:relative tw:after:left-[6px] tw:after:-top-px tw:after:w-[16px] tw:after:h-[28px] tw:after:[border-right:10px_solid_white] tw:after:[border-top:14px_solid_#0D8AE3] tw:after:[border-bottom:14px_solid_#0D8AE3] ",
	},
	companyLogo: {
		picture: "tw:max-w-[200px]",
		image: "tw:max-w-full",
	},
	trustpilotReview: {
		container: "tw:flex tw:flex-col tw:text-right tw:desktop:text-center",
		reviewCount:
			"tw:text-[#232227] tw:text-[13px] tw:leading-[16px] tw:xs2:text-[14px]",
		reviewCountNumber: "tw:font-bold tw:font-graphikWeb",
		reviewCountText: "tw:ml-[2px]",
		ratingContainer:
			"tw:my-[6px] tw:flex tw:gap-[3px] tw:justify-end tw:xs2:my-[8px]",
		starBase:
			"tw:relative tw:rounded-[3px] tw:w-[20px] tw:h-[20px] tw:flex tw:items-center tw:justify-center tw:text-white tw:text-[12px] tw:xs2:text-[14px] tw:xs2:w-[24px] tw:xs2:h-[24px]",
		ratingCountWrapper:
			"tw:w-full tw:flex tw:items-end tw:gap-[2px] tw:justify-evenly tw:text-[13px] tw:text-[#232227] tw:leading-[13px] tw:xs2:text-[14px] tw:xs2:leading-[14px]",
		ratingCount: "tw:font-bold tw:font-graphikWeb",
		ratingCountText: "",
		trustPilotLogo: "tw:h-[16px] tw:w-auto",
	},
	columnInformation: {
		wrapper: "tw:grid tw:gap-[8px] tw:desktop:flex",
		columnWrapper:
			"tw:p-[8px] tw:w-full tw:flex tw:items-center tw:gap-[8px] tw:rounded-[3px] tw:border tw:border-solid tw:border-[#ECF0F5] tw:xs2:gap-[12px] tw:desktop:w-fit",
		column: "",
		icon: "tw:w-[24px] tw:h-[24px] tw:xs:w-[32px] tw:xs:h-[32px]",
		label:
			"tw:mb-[4px] tw:font-montserrat tw:text-[12px] tw:text-[#787E81] tw:uppercase tw:font-semibold tw:leading-[16px] tw:xs2:mb-[6px]",
		value:
			"tw:text-[16px] tw:font-graphikWeb tw:leading-[20px] tw:font-semibold tw:text-[#48484B]",
	},
	mobileSocialProof: {
		wrapper: "tw:flex tw:mt-[8px] tw:justify-center tw:desktop:hidden",
		contentWrapper: "tw:flex tw:items-center tw:gap-[8px]",
		contentIcon: "tw:text-[#0D8AE3] tw:text-[20px]",
		content:
			"tw:leading-[12px] tw:font-semibold tw:text-[12px] tw:text-[#232227] tw:pt-[4px] tw:m-0",
	},
	benefitsList: {
		wrapper: "tw:w-full",
		list: "tw:m-0 tw:max-w-full tw:flex tw:flex-col tw:xs2:w-[500px] tw:desktop:w-full",
		listItem:
			"tw:mb-[8px] tw:text-pretty tw:mx-0 tw:pl-[25px] tw:text-[#48484B] tw:font-semibold tw:text-[16px] tw:leading-[24px] tw:bg-[url(/public/react-images/common/iconTick.svg)] tw:bg-no-repeat tw:bg-position-[left_top_5px] tw:last:mb-0",
		expandButton:
			"tw:w-full tw:flex tw:cursor-pointer tw:items-center tw:border-0 tw:bg-transparent tw:py-0 tw:pl-[25px] tw:text-[#0D8AE3] tw:md:mt-[20px]",
		expandBenefitsContent:
			"tw:text-[16px] tw:font-semibold tw:leading-[24px] tw:pt-[2px]",
		expandButtonIcon: "tw:ml-[8px] tw:text-[24px] tw:rotate-90",
	},
	socialProof: {
		wrapper:
			"tw:hidden tw:relative tw:desktop:flex tw:w-full tw:mb-[12px] tw:justify-center tw:border-[rgba(88,102,126,0.10)] tw:desktop:max-w-fit tw:desktop:bg-white tw:desktop:rounded-lg tw:desktop:p-2 tw:desktop:filter-[drop-shadow(0px_0px_1px_rgba(88,102,126,0.48))_drop-shadow(0px_0px_24px_rgba(88,102,126,0.10))] tw:desktop:after:absolute tw:desktop:after:right-[calc(50%-6px)] tw:desktop:after:w-2.5 tw:desktop:after:h-2.5 tw:desktop:after:translate-x-0 tw:desktop:after:-translate-y-2/4 tw:desktop:after:rotate-45 tw:desktop:after:bg-white tw:desktop:after:overflow-hidden tw:desktop:after:pointer-events-none tw:desktop:after:bottom-[-8px]",
		contentWrapper:
			"tw:flex tw:flex-row tw:justify-center tw:items-center tw:gap-2",
		contentIcon: "tw:text-[#0D8AE3] tw:text-[20px] tw:md:text-[32px]",
		content:
			"tw:leading-[12px] tw:font-semibold tw:text-[12px] tw:text-[#232227] tw:pt-[4px] tw:md:leading-[16px] tw:m-0 tw:desktop:max-w-[110px] ",
	},
	reviewLink: {
		wrapper:
			"tw:mt-[16px] tw:ml-[-8px] tw:flex tw:cursor-pointer tw:items-center tw:gap-[8px] tw:text-[#0D8AE3] tw:hover:underline tw:underline-offset-8 tw:hover:underline-offset-4 tw:transition-all tw:desktop:ml-0",
		text: "tw:text-[16px] tw:pt-[2px] tw:font-semibold tw:leading-[22px] tw:desktop:leading-[24px]",
	},
});
